import { vnTemplate } from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";

declare var ko: any;

export class videosView_template extends vnTemplate {
    protected getTemplateHtml(): string {
        return /*html*/`

                <div class="w-form w-video-view w-form-large ">

                    <div class="form-header">
                        <button data-bind="event: { click: onClickCancel }" class="btn icon i-back" type="button">Go Back</button>
                        <button data-bind="event: { click: onClickEdit   }, visible: isEditShown" class="btn icon i-edit" type="button">Edit Video</button>
                    </div>

                    <div class="w-form-body">


                        <div class="form-body">
                            <strong class="form-sub-title">Upload</strong>
                            <div class="form-group">
                                <dl class="double-list">
                                    <dt style="grid-column: 1 / span 2"><span>URL</span></dt><dd class="flex" style="grid-column: 1 / span 2;text-align: left;border-bottom: 0px solid black"><span class="no-cap" data-bind="text: url"></span><a style="margin-left: 1rem;" class="btn icon border only-icon i-full-size" target="_blank" rel="noopener noreferrer" data-bind="attr: { href: url }"></a></dd>
                                    <dt><span>Duration</span></dt><dd><span data-bind="text: length"></span></dd>
                                    <dt><span>Size</span></dt><dd><span data-bind="text: sizeHuman"></span></dd>
                                    <dt><span>Dimension</span></dt><dd><span data-bind="text: width"></span><span class="no-cap">px&nbsp;x&nbsp;</span><span data-bind="text: height"></span><span class="no-cap">px</span></dd>
                                    <dt><span>Ratio</span></dt><dd><span data-bind="text: ratio"></span></dd>
                                    <dt><span>MIME Type</span></dt><dd><span class="no-cap" data-bind="text: mimeType"></span></dd>
                                    <dt><span>Date Uploaded</span></dt><dd><span data-bind="text: dateCreated"></span></dd>
                                    <dt><span>Date Updated</span></dt><dd><span data-bind="text: dateUpdated"></span></dd>

                                </dl>
                            </div>
                            <div class="form-group">
                                <dl class="double-list">
                                    <dt class="full-width"><span>Thumbnail</span></dt>
                                    <dd class="full-width"><img style="width:400px" data-bind="attr: { src: thumbnail }"  alt="" /></dd>
                                </dl>
                            </div>
                        </div>
                        <div class="form-body">
                            <strong class="form-sub-title">Video Information</strong>
                            <div class="form-group">
                                <dl class="double-list">
                                    <dt><span>Title</span></dt><dd><span data-bind="text: title"></span></dd>
                                    <dt class="full-width"><span>Description</span></dt><dd class="full-width"><span class="no-cap" style="text-align: left;font-weight: normal;" data-bind="text: description"></span></dd>
                                    <dt><span>Under Embargo</span></dt><dd><span data-bind="text: isUnderEmbargo() === true ? 'Yes' : 'No'"></span></dd>
                                    <dt><span>Producer</span></dt><dd><span data-bind="text: producer"></span></dd>
                                </dl>
                            </div>
                            <strong class="form-sub-title">Video Article</strong>
                            <div class="form-group">
                                <button class="btn secondary icon i-video" type="button" data-bind="event: { click: onClickGenerateVideoArticle }, text: videoArticleId() ? 'View Video Article' : 'Generate Video Article'"></button>
                            </div>                            
                            <strong class="form-sub-title">Categorization</strong>
                            <div class="form-group">
                                <dl class="double-list">
                                    <dt><span>Content Type</span></dt><dd><span data-bind="text: contentType"></span></dd>
                                    <dt><span>Categories</span></dt><dd><span data-bind="text: categories"></span></dd>
                                    <dt><span>Primary Category</span></dt><dd><span data-bind="text: primaryCategory"></span></dd>
                                    <dt><span>Tags</span></dt><dd><span data-bind="text: tags"></span></dd>
                                    <dt><span>Primary Tag</span></dt><dd><span data-bind="text: primaryTag"></span></dd>
                                </dl>
                            </div>
                            <strong class="form-sub-title">Subtitles</strong>
                            <div class="form-group">
                                <dl class="double-list">
                                    <dt><span>Subtitles</span></dt><dd><span data-bind="text: subtitles"></span></dd>
                                </dl>
                            </div>
                        </div>



                    </div>
                </div>

                `;
    }

    protected initPartial(): void {}

    protected getTemplateName(): string {
        return "videosView-template";
    }

    protected buildViewModel(): any {
        let self = this;

        return {
            id: ko.observable(""),
            title: ko.observable(""),
            description: ko.observable(""),
            url: ko.observable(""),
            length: ko.observable(""),
            size: ko.observable(""),
            sizeHuman: ko.observable(""),
            height: ko.observable(""),
            width: ko.observable(""),
            ratio: ko.observable(""),
            mimeType: ko.observable(""),
            dateCreated: ko.observable(""),
            dateUpdated: ko.observable(""),
            producer: ko.observable(""),
            thumbnail: ko.observable(""),
            isUnderEmbargo: ko.observable(false),
            isEditShown: ko.observable(false),
            lockItem: ko.observable(false),
            primaryTag: ko.observable(""),
            tags: ko.observableArray([]),
            primaryCategory: ko.observable(""),
            categories: ko.observableArray([]),
            contentType: ko.observableArray(""),
            subtitles: ko.observableArray(""),
            videoArticleId: ko.observable(""),
            onClickEdit: (data) => {
                self.onClickEdit(data.id());
            },
            onClickCancel: (data, event) => {
                self.onClickCancel();
            },
            onClickGenerateVideoArticle : function (data) {
                self.generateVideoArticle(data);
            }
        };
    }

    public getViewModelForRequest() {
        return {
            lockItem: this.getTemplateViewModel().lockItem,
        };
    }

    public onClickEdit(id) {
        this.caller.edit(id);
    }

    protected onClickCancel() {
        this.caller.goBack();
    }

    public setId(id): void {
        this.getTemplateViewModel().id(id);
    }

    public setTitle(title): void {
        this.getTemplateViewModel().title(title);
    }

    public setDescription(description): void {
        this.getTemplateViewModel().description(description);
    }

    public setUrl(url): void {
        this.getTemplateViewModel().url(url);
    }

    public setLength(length): void {
        this.getTemplateViewModel().length(length);
    }

    public setSize(size): void {
        this.getTemplateViewModel().size(size);
    }

    public setSizeHuman(size): void {
        this.getTemplateViewModel().sizeHuman(this.formatBytes(size));
    }

    public setHeight(height): void {
        this.getTemplateViewModel().height(height);
    }

    public setWidth(width): void {
        this.getTemplateViewModel().width(width);
    }

    public setRatio(ratio): void {
        this.getTemplateViewModel().ratio(ratio);
    }

    public setMimeType(mimeType): void {
        this.getTemplateViewModel().mimeType(mimeType);
    }

    public setDateCreated(dateCreated): void {
        this.getTemplateViewModel().dateCreated(dateCreated);
    }

    public setDateUpdated(dateUpdated): void {
        this.getTemplateViewModel().dateUpdated(dateUpdated);
    }

    public setProducer(producer): void {
        this.getTemplateViewModel().producer(producer);
    }

    public setThumbnail(thumbnail): void {
        this.getTemplateViewModel().thumbnail(thumbnail);
    }

    public setIsUnderEmbargo(isUnderEmbargo): void {
        this.getTemplateViewModel().isUnderEmbargo(isUnderEmbargo);
    }

    public setIsEditShown(isEditShown): void {
        this.getTemplateViewModel().isEditShown(isEditShown);
    }

    public setTags(tags): void {
        this.getTemplateViewModel().tags(tags);
    }

    public setCategories(categories): void {
        this.getTemplateViewModel().categories(categories);
    }

    public setPrimaryTag(primaryTag): void {
        this.getTemplateViewModel().primaryTag(primaryTag);
    }

    public setPrimaryCategory(primaryCategory): void {
        this.getTemplateViewModel().primaryCategory(primaryCategory);
    }

    public setContentType(contentType): void {
        this.getTemplateViewModel().contentType(contentType);
    }

    public formatBytes(bytes, decimals = 2, binaryUnits = 1024) {
        if (bytes == 0) {
            return "0 Bytes";
        }
        var unitMultiple = binaryUnits ? 1024 : 1000;
        var unitNames =
            unitMultiple === 1024 // 1000 bytes in 1 Kilobyte (KB) or 1024 bytes for the binary version (KiB)
                ? ["Bytes", "KiB", "MiB", "GiB", "TiB", "PiB", "EiB", "ZiB", "YiB"]
                : ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];
        var unitChanges = Math.floor(Math.log(bytes) / Math.log(unitMultiple));
        return (
            parseFloat((bytes / Math.pow(unitMultiple, unitChanges)).toFixed(decimals || 0)) +
            " " +
            unitNames[unitChanges]
        );
    }

    public setSubtitles(subtitles): void {
        this.getTemplateViewModel().subtitles(subtitles);
    }

    public setVideoArticleId(videoArticleId): void {
        this.getTemplateViewModel().videoArticleId(videoArticleId);
    }

    protected generateVideoArticle(data) {
        
        this.caller.generateVideoArticle(data, this.getTemplateViewModel().videoArticleId());
    }
}



// WEBPACK FOOTER //
// ./js/components/templates/videosView_template.ts